import React from 'react';
import { Alert, AlertTitle, Container } from '@mui/material';
import { CheckoutRequestState } from '../../types/order';

interface CheckoutStatusBannerProps {
  state: CheckoutRequestState | null;
}

// 公開注文画面のヘッダー直下に常設する会計リクエスト状態バナー（ADR 0068）。
// 文言は顧客向けに短く、次に何をすればよいかだけを伝える。NONE / 未取得なら何も描かない。
const CheckoutStatusBanner: React.FC<CheckoutStatusBannerProps> = ({ state }) => {
  if (!state || state.status === 'NONE') {
    return null;
  }

  const paymentMethod = state.paymentMethod;

  if (state.status === 'REQUESTED') {
    return (
      <Container maxWidth="lg" sx={{ mt: 2, width: '100%' }}>
        <Alert severity="info">
          <AlertTitle>
            お会計をリクエストしました{paymentMethod ? `（お支払い方法: ${paymentMethod}）` : ''}
          </AlertTitle>
          店員がお伺いするまで少々お待ちください。追加のご注文はまだ可能です。
        </Alert>
      </Container>
    );
  }

  // ACKNOWLEDGED
  return (
    <Container maxWidth="lg" sx={{ mt: 2, width: '100%' }}>
      <Alert severity="success">
        <AlertTitle>お会計を受け付けました</AlertTitle>
        {paymentMethod && (
          <>
            お支払い方法: {paymentMethod}
            <br />
          </>
        )}
        お支払いの準備をしてお待ちください。ご注文の受付は終了しました。
      </Alert>
    </Container>
  );
};

export default CheckoutStatusBanner;
